<template>
    <span class="feather-icon select-none relative switch-publish" title="Published / Un-Published">
      <vs-switch v-model="params.data.IsPublished">
      </vs-switch>
    </span>
</template>

<script>
  import { bus } from "../../../main";
export default {
  name: 'CellRendererRoleStatus',
  watch: {
    "params.data.IsPublished"() {
        console.log("params===",this.params.data);
         bus.$emit("changeRoleStatus", this.params.data);
    }
  },
  methods: {

  },
  computed: {
 
  }
}
</script>

